import { useUser } from "@/api/user";
import { PasswordResetForm } from "@/components/auth/password-reset-form";
import { SimpleLink } from "@/components/ui/simple-link";
import commonForgeLogo from "../assets/logo.svg";

export default function PasswordReset() {
  const currentUser = useUser();

  return (
    <>
      <div className="container relative grid h-[800px] min-h-screen flex-col items-center lg:max-w-none lg:grid-cols-2 lg:px-0">
        <div className="lg:p-8">
          <div className="mx-auto flex w-full max-w-[500px] flex-col justify-center space-y-6 lg:w-[450px]">
            <div className="flex flex-col space-y-2">
              <h1 className="text-4xl font-light tracking-tight">
                Reset password
              </h1>
              <PasswordRules />
            </div>
            <PasswordResetForm />
            {!currentUser.data && (
              <div className="text-sm">
                <SimpleLink href="/">Sign in</SimpleLink>
              </div>
            )}
          </div>
        </div>
        <div className="relative hidden h-full flex-col p-10 dark:border-r lg:flex">
          <div className="absolute inset-0 bg-[url('/wind-power-plant-solar-pannels-low-angle.jpg')] bg-cover bg-center" />
          <div className="relative z-20 flex max-w-[610px] flex-col items-start">
            <img src={commonForgeLogo} className="mb-8 sm:w-[400px] xl:w-fit" />
          </div>
        </div>
      </div>
    </>
  );
}

export const PasswordRules = () => (
  <div className="text-sm text-muted-foreground">
    <p>
      To ensure the security of your account, your password must meet the
      following criteria:
    </p>
    <ul>
      <li className="flex flex-row items-center gap-x-2">
        <div>
          <div className="h-[8px] w-[8px] rounded-full bg-black" />
        </div>
        Must be at least 8 characters long.
      </li>
      <li className="flex flex-row items-center gap-x-2">
        <div>
          <div className="h-[8px] w-[8px] rounded-full bg-black" />
        </div>
        Must include at least one uppercase letter (A-Z).
      </li>
      <li className="flex flex-row items-center gap-x-2">
        <div>
          <div className="h-[8px] w-[8px] rounded-full bg-black" />
        </div>
        Must include at least one lowercase letter (a-z).
      </li>
      <li className="flex flex-row items-center gap-x-2">
        <div>
          <div className="h-[8px] w-[8px] rounded-full bg-black" />
        </div>
        Must include at least one number (0-9).
      </li>
      <li className="flex flex-row items-center gap-x-2">
        <div>
          <div className="h-[8px] w-[8px] rounded-full bg-black" />
        </div>
        Must include at least one special character from: @, #, !
      </li>
    </ul>
  </div>
);
